var _circle, _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFacebookAlt = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3947,
    cy: 19.3947,
    r: 19.3947,
    fill: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 14.528H24C24.2301 14.528 24.4167 14.3549 24.4167 14.1415V11.8229C24.4167 11.6095 24.2301 11.4365 24 11.4365H21.5C18.9698 11.4391 16.9194 13.3407 16.9167 15.6873V18.3923H14C13.7699 18.3923 13.5833 18.5653 13.5833 18.7787V21.0973C13.5833 21.3107 13.7699 21.4838 14 21.4838H16.9167V29.5988C16.9167 29.8122 17.1032 29.9853 17.3334 29.9853H19.8334C20.0635 29.9853 20.25 29.8122 20.25 29.5988V21.4838H23.1667C23.346 21.4837 23.5051 21.3772 23.5617 21.2194L24.395 18.9009C24.4678 18.6984 24.3497 18.4796 24.1314 18.4121C24.0891 18.399 24.0447 18.3923 24 18.3923H20.25V15.6873C20.25 15.047 20.8096 14.528 21.5 14.528Z",
    fill: "#626A77"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebookAlt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook-alt.3f4715c5.svg";
export { ForwardRef as ReactComponent };